import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cuponsApi } from '@/lib/api';
import type { Cupom } from '@/types';

export function useCupons(params?: { ativo?: boolean }) {
  return useQuery({
    queryKey: ['cupons', params],
    queryFn: async () => {
      const response = await cuponsApi.listar(params);
      const data = response.data;
      if (data && typeof data === 'object' && 'data' in data && Array.isArray(data.data)) {
        return data.data as Cupom[];
      }
      return (Array.isArray(data) ? data : []) as Cupom[];
    },
  });
}

export function useCupom(codigo: string) {
  return useQuery({
    queryKey: ['cupom', codigo],
    queryFn: async () => {
      const response = await cuponsApi.buscar(codigo);
      return response.data as Cupom;
    },
    enabled: !!codigo,
  });
}

export function useCriarCupom() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: any) => cuponsApi.criar(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cupons'] });
    },
  });
}

export function useAtualizarCupom() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      cuponsApi.atualizar(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cupons'] });
    },
  });
}

export function useDeletarCupom() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => cuponsApi.deletar(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cupons'] });
    },
  });
}

export function useBulkDeletarCupons() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (ids: string[]) => cuponsApi.bulkDeletar(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cupons'] });
    },
  });
}

export function useValidarCupom() {
  return useMutation({
    mutationFn: ({ codigo, data }: { codigo: string; data: any }) =>
      cuponsApi.validar(codigo, data),
  });
}
